<template>
  <div class="personal-board-page">
    <el-tabs v-model="activeTab" type="card" class="personal-board-tabs">
      <el-tab-pane label="汇总看板" name="summary">
        <toufang-self v-if="activeTab === 'summary'"></toufang-self>
      </el-tab-pane>
      <el-tab-pane label="创意看板" name="creative">
        <toufang-self-two v-if="activeTab === 'creative'"></toufang-self-two>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ToufangSelf from './ToufangSelf.vue'
import ToufangSelf2 from './ToufangSelf2.vue'

const STORAGE_KEY = 'ToufangPersonalBoard.activeTab'

export default {
  name: 'ToufangPersonalBoard',
  components: {
    ToufangSelf,
    ToufangSelfTwo: ToufangSelf2
  },
  data() {
    return {
      activeTab: localStorage.getItem(STORAGE_KEY) || 'summary'
    }
  },
  watch: {
    activeTab(value) {
      localStorage.setItem(STORAGE_KEY, value)
    }
  }
}
</script>

<style scoped>
.personal-board-page {
  width: 100%;
}

::v-deep .personal-board-tabs > .el-tabs__header {
  margin: 0;
  padding: 8px 16px 0;
  background: #f3f6fb;
}

::v-deep .personal-board-tabs > .el-tabs__content {
  overflow: visible;
}

::v-deep .personal-board-tabs > .el-tabs__header .el-tabs__item {
  height: 34px;
  line-height: 34px;
}
</style>
